import React from 'react';
import PropTypes from 'prop-types';
import { LoginSignUpModal } from '@spotahome/ui-library';

import withModalProps from './withModalProps';

const LoginModal = ({ onClose, isOpen, modalProps }) => (
  <LoginSignUpModal {...modalProps} isOpen={isOpen} onClose={onClose} />
);

LoginModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  modalProps: PropTypes.shape({}).isRequired
};

export default withModalProps()(LoginModal);
